import {
	ChangeDetectionStrategy,
	Component,
	Inject,
	OnInit,
} from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface ProceedModalData {
	noLabel?: string;
	primaryText: string;
	secondaryText: string;
	yesLabel?: string;
}

@Component({
	selector: 'app-proceed-modal',
	templateUrl: './proceed-modal.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class ProceedModalComponent implements OnInit {
	noLabel = 'No';
	primaryText!: string;
	secondaryText!: string;
	yesLabel = 'Yes';

	constructor(
		public dialogRef: MatDialogRef<ProceedModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: ProceedModalData,
	) {}

	ngOnInit(): void {
		const { data } = this;

		this.primaryText = data.primaryText;
		this.secondaryText = data.secondaryText;

		if (data.yesLabel) {
			this.yesLabel = data.yesLabel;
		}
		if (data.noLabel) {
			this.noLabel = data.noLabel;
		}
	}

	onNoClick(): void {
		this.dialogRef.close(false);
	}

	onYesClick(): void {
		this.dialogRef.close(true);
	}
}
